import type { AvailableMap } from 'app/modules/machine-inventory/ScheduleClient';
import {
  CleaningModeEnum,
  CleaningSuctionEnum,
  type Map,
} from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

export interface RobotScheduleMapSelectOption {
  label: string;
  value: string;
  map: Map;
}

export interface RobotScheduleMapGroup {
  groupId: string;
  groupName: string;
  maps: AvailableMap[];
}

export const SUCTION_MODE_OPTIONS = [
  { label: 'common.normal', value: CleaningSuctionEnum.Normal, icon: 'normalMode' },
  { label: 'common.eco', value: CleaningSuctionEnum.Eco, icon: 'ecoMode' },
];

export const CLEANING_MODE_OPTIONS = [
  { label: 'createSchedule.wholeMap', value: CleaningModeEnum.WholeMap },
  { label: 'createSchedule.area', value: CleaningModeEnum.Area },
];
